import { Link } from "react-router-dom";
import { SessionScience } from "@/components/SessionScience";
import { Reveal } from "@/components/Reveal";

export default function SciencePage() {
  return (
    <>
      <section className="border-b border-[#E2ECEE] bg-white">
        <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8 lg:py-16">
          <span className="text-xs font-extrabold uppercase tracking-wider text-[#F97316]">Multi-sport & neuro-physical</span>
          <h1 className="mt-2 font-head text-4xl font-extrabold text-slate-900 sm:text-5xl">The science behind the fun</h1>
          <p className="mt-4 max-w-2xl text-base text-slate-600">
            SplayLab sessions aren't random games. Each 30–45 minute session follows a deliberate 4-stage flow that develops the brain and body together.
          </p>
        </div>
      </section>
      <Reveal><SessionScience /></Reveal>
      <section className="mx-auto max-w-5xl px-5 py-16 text-center lg:px-8">
        <h2 className="font-head text-3xl font-extrabold text-slate-900">Want this for your centre or child?</h2>
        <Link to="/inquire" className="mt-5 inline-flex rounded-full bg-[#F97316] px-8 py-3.5 font-head text-base font-extrabold text-white shadow-lg hover:bg-[#ea6a0c]">
          Inquire for Program Pricing
        </Link>
      </section>
    </>
  );
}
